import AprovarPassagem from './componentes/AprovarPassagem.vue';
import AprovarPassagemLista from './componentes/AprovarPassagemLista.vue';
import AprovarPassagemRelatorio from './componentes/AprovarPassagemRelatorio.vue';

export default {
  path: '/aprovar-passagem',
  component: AprovarPassagem,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: AprovarPassagemLista,
      name: 'aprovar-passagem',
    },
    {
      path: ':id/relatorio',
      component: AprovarPassagemRelatorio,
      name: 'aprovar-passagem.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/aprovar-passagem/rotas.js